export default __webpack_public_path__ + "static/text-mask-video-8d7f521080e108d4231b0e2abbf7a4d3.mp4";